import { Avatar, type AvatarRootProps, LuIcon } from "@overmap-ai/blocks"
import { type User } from "@overmap-ai/common"
import { selectUserById } from "@overmap-ai/core"
import { forwardRef, memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { useAppSelector } from "../../store"
import { getUserDisplayInitials, getUserDisplayLabel } from "../../utils/users"

interface UserIconProps extends AvatarRootProps {
	userId?: User["id"]
}

export const UserIcon = memo(
	forwardRef<HTMLSpanElement, UserIconProps>((props, ref) => {
		const {
			userId,
			className,
			size = "sm",
			radius = "full",
			accentColor = "base",
			variant = "soft",
			...rest
		} = props

		const user = useAppSelector(selectUserById(userId ?? -1))

		return (
			<Avatar.Root
				ref={ref}
				className={className}
				size={size}
				accentColor={accentColor}
				variant={variant}
				radius={radius}
				{...rest}
			>
				{user?.profile.object_url ? (
					<Avatar.Image src={user.profile.object_url} alt={getUserDisplayLabel(user)} />
				) : null}
				<Avatar.Fallback>
					{user ? getUserDisplayInitials(user) : <LuIcon icon={modelIconMapping.question} />}
				</Avatar.Fallback>
			</Avatar.Root>
		)
	}),
)
